module.exports = __webpack_public_path__ + "img/safe.1f1c9334.webp";